module.exports = __webpack_public_path__ + "static/media/password_100.242fe10c.ico";